import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import classNames from 'classnames';
import { DashboardModal } from '@/shared/components/dashboards/Modal';
import { TokenWithChainByAsset } from '@/shared/components/logo/TokenWithChain';
import CloseIcon from '@/shared/icons/flip-ui-kit/large/Close';
import { chainflipAssetMap } from '@/shared/utils/env';
import SuccessIllustration from '../../public/success-illustration.svg';

export const StrategySuccessModal = ({
  open,
  onClose,
  afterLeave,
  title,
  baseAsset,
  children,
  className,
}: {
  open: boolean;
  onClose: () => void;
  afterLeave: () => void;
  title: string;
  baseAsset: ChainflipAsset;
  children: React.ReactNode;
  className?: string;
}) => (
  <DashboardModal open={open} onClose={onClose} afterLeave={afterLeave}>
    <div
      className={classNames(
        'flex w-[496px] flex-col gap-6 rounded-md border border-cf-gray-4 bg-cf-gray-3 p-6',
        className,
      )}
    >
      <div className="flex justify-end">
        <button type="button" onClick={onClose} className="outline-cf-gray-5">
          <CloseIcon />
        </button>
      </div>
      <div className="my-auto flex w-full flex-col items-center justify-center">
        <div className="mb-[-74px]">
          <SuccessIllustration />
        </div>
        <div className="flex flex-col items-center font-aeonikMedium">
          <span className="text-24 text-cf-white">{title}</span>
          <span className="flex items-center gap-x-1">
            <TokenWithChainByAsset asset={baseAsset} />
            <span>{chainflipAssetMap[baseAsset].symbol}</span>
          </span>
        </div>
      </div>
      {children}
    </div>
  </DashboardModal>
);
